import {createStore, applyMiddleware} from 'redux'
import {createLogger} from 'redux-logger'
import thunk from 'redux-thunk'
import rootReducer from '../reducer'

const logger = createLogger()

const createStoreWithMiddleware = applyMiddleware(thunk, logger)(createStore)

export function configureStore(initialState) {
    return createStoreWithMiddleware(rootReducer, initialState);
}